import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FilterState {
    selectedFilters: { [key: string]: string[] };
    detailedFilters: Record<string, { options: { column_value: string; display_name: string; is_applied: boolean | null }[]; display_name: string }>;
    selectedDemographics: { [key: string]: string[] };
    detailedDemographics: Record<string, { options: { column_value: string; display_name: string; is_applied: boolean | null }[]; display_name: string }>;
}

const initialState: FilterState = {
    selectedFilters: {},
    detailedFilters: {},
    selectedDemographics: {},
    detailedDemographics: {},
};

// Create the slice
const filterSlice = createSlice({
    name: "filters",
    initialState,
    reducers: {
        setFilters: (
            state,
            action: PayloadAction<{
                selected: { [key: string]: string[] };
                details: Record<string, { options: { column_value: string; display_name: string; is_applied: boolean | null }[]; display_name: string }>;
            }>,
        ) => {
            state.selectedFilters = action.payload.selected;
            state.detailedFilters = action.payload.details;
        },
        resetSelectedFilters: (state) => {
            state.selectedFilters = {};
            state.detailedFilters = {};
        },
        setDemographicOptions: (
            state,
            action: PayloadAction<{
                selectedDemographics: { [key: string]: string[] };
                detailedDemographics: Record<string, { options: { column_value: string; display_name: string; is_applied: boolean | null }[]; display_name: string }>;
            }>,
        ) => {
            state.selectedDemographics = action.payload.selectedDemographics;
            state.detailedDemographics = action.payload.detailedDemographics;
        },
        resetDemographicOptions: (state) => {
            state.selectedDemographics = {};
            state.detailedDemographics = {};
        },
    },
});

// Export the actions
export const { setFilters, resetSelectedFilters, setDemographicOptions, resetDemographicOptions } = filterSlice.actions;

// Export the reducer to add it to the store
export default filterSlice.reducer;
